export default __webpack_public_path__ + "static/media/san_diego.f1c0ff23.jpg";